import { ChangeEvent, FormEvent, useState } from "react";
import { SoftwareCreate } from "../../models/Softwares/SoftwareCreate";
import { Box, Button, TextField } from "@mui/material";

interface Props {
  selectedSoftware: SoftwareCreate;
  closeForm: () => void;
  edit: (software: SoftwareCreate) => void;
}

export default function EditSoftwareForm({ selectedSoftware, closeForm, edit }: Props) {
  const [softwareData, setSoftwareData] = useState<SoftwareCreate>(selectedSoftware);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    edit(softwareData);
  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setSoftwareData({ ...softwareData, [name]: value });
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        label="Software Name"
        name="softwareName"
        value={softwareData.softwareName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Prefix Name"
        name="prefixName"
        value={softwareData.prefixName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Description"
        name="description"
        value={softwareData.description}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        multiline
      />

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
        <Button variant="outlined" onClick={closeForm}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
